import React, { useState, useEffect } from 'react';
import { ProductTexts } from '../contexts/LangProduct';
import { useNavigate } from 'react-router-dom';
import haycyonImg from '../assets/images/halcyon.png';
import primxImg from '../assets/images/primx.png';
import kosmosImg from '../assets/images/1kosmos.png';
import proofpointImg from '../assets/images/proofpoint.png';
import mobileumImg from '../assets/images/mobileum.png';

function Productintro({ lang = 'ko' }) {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const images = [primxImg, kosmosImg, proofpointImg, mobileumImg];

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const textMap = [
    {
      title: ProductTexts.Primxtitle[lang],
      message: ProductTexts.Primxmessage[lang],
      btn: ProductTexts.Detailbtn[lang],
      link: '/product/primx-zc'
    },
    {
      title: ProductTexts.Kosmostitle[lang],
      message: ProductTexts.Kosmosmessage[lang],
      btn: ProductTexts.Detailbtn[lang],
      link: '/product/1kosmos'
    },
    {
      title: ProductTexts.ObserveITtitle[lang],
      message: ProductTexts.ObserveITmessage[lang],
      btn: ProductTexts.Detailbtn[lang],
      link: '/product/proofpoint-oit'
    },
    {
      title: ProductTexts.Mobileumtitle[lang],
      message: ProductTexts.Mobileummessage[lang],
      btn: ProductTexts.Detailbtn[lang],
      link: '/product/mobileum'
    }
  ];

  return (
    <section
      style={{
        width: '100%',
        maxWidth: '100vw',
        minHeight: '600px',
        background: '#111',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        position: 'relative',
        padding: isMobile ? '48px 20px' : '64px 5vw',
        boxSizing: 'border-box',
        color: '#fff'
      }}
    >
      <h1 style={{
        fontSize: isMobile ? '2.2rem' : '2.8rem',
        fontWeight: 800,
        marginBottom: 24,
        textAlign: 'center',
        letterSpacing: '-1px',
        marginTop: 0,
        padding: isMobile ? '0 10px' : '0'
      }}>
        <br /><br />{ProductTexts.Producttitle[lang]}
      </h1>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: isMobile ? '24px' : '32px',
          width: '100%',
          maxWidth: 1600,
          justifyContent: 'center',
          marginTop: isMobile ? 40 : 56
        }}
      >
        <ProductHalcyon lang={lang} isMobile={isMobile} />
        <ProductPrimx lang={lang} isMobile={isMobile} />
        <Product1kosmos lang={lang} isMobile={isMobile} />
        <ProductObserveIT lang={lang} isMobile={isMobile} />
        {/* <ProductMobileum lang={lang} isMobile={isMobile} /> */}
      </div>
    </section>
  );
}

function ProductHalcyon({ lang = 'ko', isMobile = false }) {
  const navigate = useNavigate();
  return (
    <div
      style={{
        flex: isMobile ? '1 1 100%' : '1 1 260px',
        minWidth: isMobile ? 'auto' : 300,
        maxWidth: isMobile ? 'none' : 320,
        background: '#f7f7fa',
        borderRadius: 18,
        boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
        padding: isMobile ? '24px 20px 28px 20px' : '30px 24px 32px 24px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        height: isMobile ? 'auto' : '580px',
        minHeight: isMobile ? '520px' : '580px'
      }}
    >
      <img
        src={haycyonImg}
        alt="제품 이미지"
        style={{
          display: 'block',
          width: isMobile ? '160px' : '200px',
          height: isMobile ? '160px' : '200px',
          objectFit: 'contain',
          aspectRatio: '1 / 1',
          margin: '0 auto 18px auto'
        }}
      />
      <h2 style={{
        fontSize: isMobile ? '1.1rem' : '1.2rem',
        fontWeight: 700,
        marginBottom: 12,
        color: '#444',
        textAlign: 'center',
        width: '100%'
      }}>
        {ProductTexts.Halcyontitle[lang]}
      </h2>
      <p style={{
        fontSize: '1rem',
        color: '#444',
        marginBottom: 18,
        lineHeight: 1.7,
        textAlign: 'center',
        width: '100%',
        flex: 1
      }}>
        {ProductTexts.Halcyonmessage[lang]}
      </p>
      <button
        style={{
          padding: '10px 20px',
          fontSize: '1rem',
          fontWeight: 700,
          color: '#fff',
          background: '#29225C',
          border: 'none',
          borderRadius: 8,
          cursor: 'pointer',
          marginTop: 0
        }}
        onClick={() => navigate('/product/halcyon')}
      >
        {ProductTexts.Detailbtn[lang]}
      </button>
    </div>
  );
}

function ProductPrimx({ lang = 'ko', isMobile = false }) {
  const navigate = useNavigate();
  return (
    <div
      style={{
        flex: isMobile ? '1 1 100%' : '1 1 260px',
        minWidth: isMobile ? 'auto' : 300,
        maxWidth: isMobile ? 'none' : 320,
        background: '#f7f7fa',
        borderRadius: 18,
        boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
        padding: isMobile ? '24px 20px 28px 20px' : '30px 24px 32px 24px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        height: isMobile ? 'auto' : '580px',
        minHeight: isMobile ? '520px' : '580px'
      }}
    >
      <img
        src={primxImg}
        alt="제품 이미지"
        style={{
          display: 'block',
          width: isMobile ? '160px' : '200px',
          height: isMobile ? '160px' : '200px',
          objectFit: 'contain',
          aspectRatio: '1 / 1',
          margin: '0 auto 18px auto'
        }}
      />
      <h2 style={{
        fontSize: '1.2rem',
        fontWeight: 700,
        marginBottom: 12,
        color: '#444',
        textAlign: 'center',
        width: '100%'
      }}>
        {ProductTexts.Primxtitle[lang]}
      </h2>
      <p style={{
        fontSize: '1rem',
        color: '#444',
        marginBottom: 18,
        lineHeight: 1.7,
        textAlign: 'center',
        width: '100%',
        flex: 1
      }}>
        {ProductTexts.Primxmessage[lang]}
      </p>
      <button
        style={{
          padding: '10px 20px',
          fontSize: '1rem',
          fontWeight: 700,
          color: '#fff',
          background: '#29225C',
          border: 'none',
          borderRadius: 8,
          cursor: 'pointer',
          marginTop: 0
        }}
        onClick={() => navigate('/product/primx-zc')}
      >
        {ProductTexts.Detailbtn[lang]}
      </button>
    </div>
  );
}

function Product1kosmos({ lang = 'ko', isMobile = false }) {
  const navigate = useNavigate();
  return (
    <div
      style={{
        flex: isMobile ? '1 1 100%' : '1 1 260px',
        minWidth: isMobile ? 'auto' : 300,
        maxWidth: isMobile ? 'none' : 320,
        background: '#f7f7fa',
        borderRadius: 18,
        boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
        padding: isMobile ? '24px 20px 28px 20px' : '30px 24px 32px 24px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        height: isMobile ? 'auto' : '580px',
        minHeight: isMobile ? '520px' : '580px'
      }}
    >
      <img
        src={kosmosImg}
        alt="제품 이미지"
        style={{
          display: 'block',
          width: isMobile ? '160px' : '200px',
          height: isMobile ? '160px' : '200px',
          objectFit: 'contain',
          aspectRatio: '1 / 1',
          margin: '0 auto 18px auto'
        }}
      />
      <h2 style={{
        fontSize: isMobile ? '1.1rem' : '1.2rem',
        fontWeight: 700,
        marginBottom: 12,
        color: '#444',
        textAlign: 'center',
        width: '100%'
      }}>
        {ProductTexts.Kosmostitle[lang]}
      </h2>
      <p style={{
        fontSize: '1rem',
        color: '#444',
        marginBottom: 18,
        lineHeight: 1.7,
        textAlign: 'center',
        width: '100%',
        flex: 1
      }}>
        {ProductTexts.Kosmosmessage[lang]}
      </p>
      <button
        style={{
          padding: '10px 20px',
          fontSize: '1rem',
          fontWeight: 700,
          color: '#fff',
          background: '#29225C',
          border: 'none',
          borderRadius: 8,
          cursor: 'pointer',
          marginTop: 0
        }}
        onClick={() => navigate('/product/1kosmos')}
      >
        {ProductTexts.Detailbtn[lang]}
      </button>
    </div>
  );
}

// 새 컴포넌트: ProductObserveIT
function ProductObserveIT({ lang = 'ko', isMobile = false }) {
  const navigate = useNavigate();
  return (
    <div
      style={{
        flex: isMobile ? '1 1 100%' : '1 1 260px',
        minWidth: isMobile ? 'auto' : 300,
        maxWidth: isMobile ? 'none' : 320,
        background: '#f7f7fa',
        borderRadius: 18,
        boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
        padding: isMobile ? '24px 20px 28px 20px' : '30px 24px 32px 24px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        height: isMobile ? 'auto' : '580px',
        minHeight: isMobile ? '520px' : '580px'
      }}
    >
      <img
        src={proofpointImg}
        alt="제품 이미지"
        style={{
          display: 'block',
          width: isMobile ? '160px' : '200px',
          height: isMobile ? '160px' : '200px',
          objectFit: 'contain',
          aspectRatio: '1 / 1',
          margin: '0 auto 18px auto'
        }}
      />
      <h2 style={{
        fontSize: isMobile ? '1.1rem' : '1.2rem',
        fontWeight: 700,
        marginBottom: 12,
        color: '#444',
        textAlign: 'center',
        width: '100%'
      }}>
        {ProductTexts.ObserveITtitle[lang]}
      </h2>
      <p style={{
        fontSize: '1rem',
        color: '#444',
        marginBottom: 18,
        lineHeight: 1.7,
        textAlign: 'center',
        width: '100%',
        flex: 1
      }}>
        {ProductTexts.ObserveITmessage[lang]}
      </p>
      <button
        style={{
          padding: '10px 20px',
          fontSize: '1rem',
          fontWeight: 700,
          color: '#fff',
          background: '#29225C',
          border: 'none',
          borderRadius: 8,
          cursor: 'pointer',
          marginTop: 0
        }}
        onClick={() => navigate('/product/proofpoint-oit')}
      >
        {ProductTexts.Detailbtn[lang]}
      </button>
    </div>
  );
}

function ProductMobileum({ lang = 'ko', isMobile = false }) {
  const navigate = useNavigate();
  return (
    <div
      style={{
        flex: isMobile ? '1 1 100%' : '1 1 260px',
        minWidth: isMobile ? 'auto' : 300,
        maxWidth: isMobile ? 'none' : 320,
        background: '#f7f7fa',
        borderRadius: 18,
        boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
        padding: isMobile ? '24px 20px 28px 20px' : '30px 24px 32px 24px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        height: isMobile ? 'auto' : '580px',
        minHeight: isMobile ? '520px' : '580px'
      }}
    >
      <img
        src={mobileumImg}
        alt="제품 이미지"
        style={{
          display: 'block',
          width: isMobile ? '160px' : '200px',
          height: isMobile ? '160px' : '200px',
          objectFit: 'contain',
          aspectRatio: '1 / 1',
          margin: '0 auto 18px auto'
        }}
      />
      <h2 style={{
        fontSize: isMobile ? '1.1rem' : '1.2rem',
        fontWeight: 700,
        marginBottom: 12,
        color: '#444',
        textAlign: 'center',
        width: '100%'
      }}>
        {ProductTexts.Mobileumtitle[lang]}
      </h2>
      <p style={{
        fontSize: '1rem',
        color: '#444',
        marginBottom: 18,
        lineHeight: 1.7,
        textAlign: 'center',
        width: '100%',
        flex: 1
      }}>
        {ProductTexts.Mobileummessage[lang]}
      </p>
      <button
        style={{
          padding: '10px 20px',
          fontSize: '1rem',
          fontWeight: 700,
          color: '#fff',
          background: '#29225C',
          border: 'none',
          borderRadius: 8,
          cursor: 'pointer',
          marginTop: 0
        }}
        onClick={() => navigate('/product/mobileum')}
      >
        {ProductTexts.Detailbtn[lang]}
      </button>
    </div>
  );
}

export default Productintro;